import React, { useState, useEffect } from "react";
import {
  AdjustmentsVerticalIcon,
  CalendarDaysIcon,
} from "@heroicons/react/24/outline";
import DatePicker from "react-tailwindcss-datepicker";
import {
  useDeleteLeadMutation,
  useGetAllPendingMatchesInfoQuery,
  useLazyGetAllFilteredPendingMatchQuery,
  useLazyGetAllPendingMatchesInfoQuery,
} from "../../../../store/admin/matchesInfo";
import Loader from "../../../commons/Loader";
import moment from "moment";
import PendingMatchesTable from "./tables/PendingMatchesTable";
import DeleteSmsModal from "../../../modal/DeleteSmsModal";
import { toast } from "react-toastify";
import SkeletonTable from "../../../commons/Skeleton/SkeletonTable";

const PendingMatchesPage = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLead, setDeleteLead] = useState(null);
  const [allPendingMatchesData, setAllPendingMatchesData] = useState();
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  const { data: allPendingMatchesInfo } = useGetAllPendingMatchesInfoQuery();
  const [refetch, { data, isFetching }] = useLazyGetAllPendingMatchesInfoQuery();
  const [
    getAllFilteredPendingMatches,
    {
      data: filteredPendingMatches,
      isLoading: filteredPendingMatchesLoader,
      isFetching: isFetchingFilteredPendingMatches,
    },
  ] = useLazyGetAllFilteredPendingMatchQuery();

  const [
    deletePendingLead,
    {
      data:deletePendingLeadData,
      isSuccess: deletePendingLeadSuccess,
      isLoading: deletePendingLeadLoader,
      isError: deleteLeadIsError,
      error: deleteLeadError,
    },
  ] = useDeleteLeadMutation();

  useEffect(() => {
    if (!deletePendingLeadLoader) {
      if (deletePendingLeadSuccess) {
        toast.success(deletePendingLeadData.message);
        refetch()
      } else if (deleteLeadIsError && deleteLeadError) {
        toast.error('Something went wrong, please try again');
      }
      setShowDeleteModal(false);
      setDeleteLead(null);
    }
  }, [deletePendingLeadSuccess,deleteLeadIsError]);

  useEffect(() => {
    if (filteredPendingMatches) {
      setAllPendingMatchesData(filteredPendingMatches);
    }
  }, [filteredPendingMatches]);

  useEffect(() => {
    if (allPendingMatchesInfo) {
      setAllPendingMatchesData(allPendingMatchesInfo);
    }
  }, [allPendingMatchesInfo]);

  useEffect(() => {
    if (data) {
      setAllPendingMatchesData(data);
    }
  }, [data]);

  useEffect(() => {
    if (isFetching) {
      setAllPendingMatchesData({});
    }
  }, [isFetching]);

  const handleValueChange = (newValue) => {
    getAllFilteredPendingMatches({
      page: 1,
      startDate: newValue.startDate,
      endDate: newValue.endDate,
    });
    setValue(newValue);
  };

  const handleDropDownMenu = (eventType, data) => {
    switch (eventType) {
      case "delete":
        setShowDeleteModal(true);
        setDeleteLead(data);
        break;
    }
  };

  // if (filteredPendingMatchesLoader) return <SkeletonTable />;

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-start md:items-center flex-col md:flex-row gap-5 mb-5">
        <h3 className="text-xl leading-[160%] font-bold text-[#04091E]">
          Pending Matches
        </h3>
        <div className="flex items-start md:items-center gap-3.5 md:gap-[30px] flex-col md:flex-row md:max-w-[400px] justify-between w-full">
          <div className="rounded-md custom-date-picker cdp-new flex items-center md:max-w-[320px] w-full border border-[#ebeff3] bg-white py-2 h-12 cursor-pointer relative z-[1]">
            <div className="pr-3 mr-3 border-r border-[#EBEFF3] absolute left-5 -z-[1]">
              <CalendarDaysIcon className="w-6 h-6" />
            </div>
            <div className="w-full professional-datepicker">
              <DatePicker
                primaryColor={"blue"}
                value={value}
                toggleClassName="hidden"
                onChange={handleValueChange}
                displayFormat={"MM/DD/YYYY"}
                showShortcuts={true}
                useRange={false}
                maxDate={moment().toDate()}
                readOnly
              />
            </div>
          </div>
          <button className="w-full md:w-12 h-12 flex items-center justify-center gap-2.5 md:gap-0 rounded-[10px] bg-[#EBEFF3]">
            <AdjustmentsVerticalIcon className="w-6 h-6 text-[#485868]" />
            <span className="text-sm font-bold leading-[160%] text-[#485868] block md:hidden">
              Filter
            </span>
          </button>
        </div>
      </div>
      <PendingMatchesTable
        pendingMatchData={allPendingMatchesData}
        getUpdateData={(page, perPage) => {
          getAllFilteredPendingMatches({
            page,
            perPage,
            startDate: value.startDate,
            endDate: value.endDate,
          });
        }}
        handleDropDownMenu={handleDropDownMenu}
      />
      <DeleteSmsModal
        isOpen={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDelete={() => deletePendingLead(deleteLead.id)}
        deleteLoader={deletePendingLeadLoader}
        text="Do you really want to delete this Lead?"
      />
    </div>
  );
};

export default PendingMatchesPage;
